import { render } from "./page-contact-us.vue?vue&type=template&id=9406eddc&scoped=true"
import script from "./page-contact-us.vue?vue&type=script&lang=js"
export * from "./page-contact-us.vue?vue&type=script&lang=js"

import "./page-contact-us.vue?vue&type=style&index=0&id=9406eddc&scoped=true&lang=css"

import exportComponent from "D:\\project\\BahteraAdhiguna\\deployment\\ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9406eddc"]])

export default __exports__